export default "__VITE_ASSET__B5T9Klxe__"